

import React, { useEffect, useState } from 'react';

const GuessTheNumber = () => {
  const [number, setNumber] = useState(Math.floor(Math.random() * 100) + 1);
  const [guess, setGuess] = useState('');
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      let finalTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        }
      }
      if (finalTranscript) {
        setGuess(finalTranscript);
        checkGuess(finalTranscript);
      }
    };

    recognition.start();
    return () => recognition.stop();
  }, []);

  const checkGuess = (guess) => {
    const num = parseInt(guess);
    if (num === number) {
      setFeedback('Correct!');
      setNumber(Math.floor(Math.random() * 100) + 1);
    } else if (num > number) {
      setFeedback('Too high!');
    } else {
      setFeedback('Too low!');
    }
  };

  return (
    <div>
      <h2>Guess the Number</h2>
      <p>Guess a number between 1 and 100</p>
      <p>{guess}</p>
      <p>{feedback}</p>
    </div>
  );
};

export default GuessTheNumber;


